import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ChapterOne from './pages/ChapterOne';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/chapter-one" element={<ChapterOne />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
